import React, { useState, useEffect } from 'react';
import TestimonialSlider1 from '../../components/slider/TestimonialSlider1';
import testimonialoneimg from '../../assets/images/testimonial/testimonial-one-img-1.jpg';

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/testimonials/`)
      .then(res => res.json())
      .then(data => setTestimonials(data))
      .catch(err => console.error(err));
  }, []);

  return (
    <>
      {/*Testimonial One Start*/}
      <section className="testimonial-one">
        <div className="container">
          <div className="testimonial-one__inner">
            <div className="testimonial-one__img-one">
              <img src={testimonialoneimg} alt="" />
            </div>
            <div className="text-center section-title">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">clients testimonial</span>
              </div>
              <h2 className="mb-5 section-title__title">
              Trusted Voices from 
                <br /> Sunrising Cinevision 
              </h2>
            </div>
            <div className="row">
              <div className="col-xl-5" />
              <div className="col-xl-7 col-lg-9">
                <div className="mt-6 testimonial-one__right">
                  <TestimonialSlider1 testimonials={testimonials} />
                </div>
              </div>
            </div>
            <div className="testimonial-one__dot-style">
              <div className="swiper-dot-style1" />
            </div>
          </div>
        </div>
      </section>
      {/*Testimonial One End*/}
    </>
  );
};

export default TestimonialsSection;
